//all functions for home.
import ReactOnRails from 'react-on-rails';

import './index';

import SearchForm from './components/search/search_form';
import NewsletterForm from './../../layout/components/newsletter/newsletter_form';
import LoggedInNotification from './../../layout/components/logged_in_notify';
import HeadlinesSlider from './components/headlines_slider/headlines_slider';
import MobileHeadlinesSlider from './components/headlines_slider/mobile_headlines_slider';
import OffersSection from './components/offers_section/offers';
import CategoriesSection from './components/categories_section/categories';
import RecommendedRegions from './components/recommended_regions';

ReactOnRails.register({
  SearchForm,
  NewsletterForm,
  LoggedInNotification,
  HeadlinesSlider,
  MobileHeadlinesSlider,
  OffersSection,
  CategoriesSection,
  RecommendedRegions
});



// WEBPACK FOOTER //
// ./app/javascript/pages/home/registration.jsx